import { useApp } from "@/context/AppContext";

export function PageHeader({ title, subtitle, action }) {
  return (
    <div className="flex flex-wrap items-end justify-between gap-4 mb-6">
      <div>
        <h1 className="font-head text-2xl sm:text-3xl font-bold tracking-tight" data-testid="page-title">{title}</h1>
        {subtitle && <p className="text-sm text-muted-foreground mt-1">{subtitle}</p>}
      </div>
      {action}
    </div>
  );
}

export function StatCard({ icon: Icon, label, value, sub, tone = "primary", testid }) {
  const tones = {
    primary: "text-primary bg-primary/10",
    amber: "text-amber-500 bg-amber-500/10",
    sky: "text-sky-500 bg-sky-500/10",
    red: "text-destructive bg-destructive/10",
  };
  return (
    <div className="rounded-xl border border-border bg-card p-5" data-testid={testid}>
      <div className="flex items-start justify-between">
        <div>
          <div className="text-xs uppercase tracking-[0.1em] font-semibold text-muted-foreground">{label}</div>
          <div className="mt-2 font-head text-3xl font-bold tabular-nums">{value}</div>
          {sub && <div className="mt-1 text-xs text-muted-foreground">{sub}</div>}
        </div>
        <div className={`h-11 w-11 rounded-lg flex items-center justify-center ${tones[tone]}`}>
          <Icon size={22} />
        </div>
      </div>
    </div>
  );
}

export function EmptyRow({ colSpan, text = "Kayıt bulunamadı." }) {
  return (
    <tr>
      <td colSpan={colSpan} className="text-center py-10 text-sm text-muted-foreground">{text}</td>
    </tr>
  );
}
